/*********************************************************
 * Third Components
*********************************************************/
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

/*********************************************************
 * Components
*********************************************************/
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { Button, Input } from 'Components';
import ColorSelector from 'Components/ColorSelector'

/*********************************************************
 * Style
*********************************************************/
import './style.scss';

/*********************************************************
 * Redux
*********************************************************/
import {
  showModalNewLandmarkGroup,
  showModalEditLandmarkGroup,
  createLandmarkGroup,
  updateLandmarkGroup
} from 'Redux/actions';

/*********************************************************
 * Class to perform edit and save Landmarks Groups
*********************************************************/
const ModalEditLandmarkGroup = (props) => {

  const { messages } = props

  const dispatch = useDispatch()
  const [landmarkGroupText, setLandmarkGroupText] = useState('')
  const [valueColor, setValueColor] = useState({ id: 0, color: '#FFFFFF' })

  /*********************************************************
   * Get the redux properties
  *********************************************************/
  const {
    smodalLandmarkGroupNew,
    smodalLandmarkGroupEdit,
    landmarkGroupItem
  } = useSelector((state) => state.realtimeMapLandmarkModuleRedux);

  /*********************************************************
   * Create the defauls values when modal is 
   * to new landmarkGroup
  *********************************************************/
  useEffect(() => {
    if (smodalLandmarkGroupNew) {
      setLandmarkGroupText('')
      setValueColor({ id: 0, color: '#FFFFFF' })
    }
  }, [smodalLandmarkGroupNew])

  /*********************************************************
   * Load the default elements when modal is edit mode
  *********************************************************/
  useEffect(() => {
    if (landmarkGroupItem) {
      setLandmarkGroupText(landmarkGroupItem?.name)
      setValueColor({ id: landmarkGroupItem?.id, color: `#${landmarkGroupItem?.color}` })
    }
  }, [landmarkGroupItem])

  /*********************************************************
   * Close modal
  *********************************************************/
  const onHandleClose = () => {
    dispatch(showModalNewLandmarkGroup(false))
    dispatch(showModalEditLandmarkGroup(false))
  }

  /*********************************************************
   * Perform the create or update landmark groups items
  *********************************************************/
  const onUpdateLandmarkGroup = () => {
    if (smodalLandmarkGroupEdit) {
      //Edit Landmark Group
      const newUpdateElement = {
        id: landmarkGroupItem?.id,
        name: landmarkGroupText,
        color: valueColor.color.replace('#', '')
      }
      dispatch(updateLandmarkGroup(newUpdateElement))
    } else {
      //Create new Element
      const newCreateElement = {
        name: landmarkGroupText,
        color: valueColor.color.replace('#', '')
      }
      dispatch(createLandmarkGroup(newCreateElement))
    }
    //Close Modal
    onHandleClose()
  }

  const onHandeChange = (event) => {
    setValueColor(event)
  }

  return (
    <Modal
      title={smodalLandmarkGroupEdit
        ? messages["realtimemaps_landmarks_groups_edit_modal"]
        : messages["realtimemaps_landmarks_groups_new_modal"]
      }
      open={smodalLandmarkGroupEdit || smodalLandmarkGroupNew || false}
      handleClose={() => {
        onHandleClose()
      }}
      position="right"
      size="small"
    >
      <ModalBody>
        <div className='modalManageVisibleLandmark'>
          <Grid container spacing={0}>
            <Grid item xs={11}>
              <Input
                id="txtLabelGroup"
                type="text"
                placeholder={messages['land_mark_title']}
                value={landmarkGroupText}
                onChange={(text) => {
                  setLandmarkGroupText(text);
                }}
                //this is a business rule, you cannot alter the name of the group 'Default Group'
                disabled={landmarkGroupItem?.name == 'Default Group'}
              />
            </Grid>
            <Grid item xs={1}>
              <div className='modalColorSelector'>
                <ColorSelector
                  className='colorContainerClass'
                  id={valueColor.id}
                  color={valueColor.color}
                  onHandeChange={(event) => onHandeChange(event)}
                />
              </div>
            </Grid>
          </Grid>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          id={'btn-save-vehicle-group'}
          type="button"
          onClick={(event) => {
            event.preventDefault();
            onHandleClose()

          }}
          className="btn-gray"
        >
          {messages['close']}
        </Button>

        <Button
          id={'btn-save-vehicle-group'}
          type="button"
          onClick={(event) => {
            event.preventDefault();
            onUpdateLandmarkGroup();
          }}
          className="btn-blue"
          disabled={landmarkGroupText.length < 3} //name more than 3 words
        >
          {messages['save']}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ModalEditLandmarkGroup